module.exports = __webpack_public_path__ + "img/Pro-money truck-desktop.b38e4034.jpg";